import ScienceTeam from "@/sections/ScienceTeam";
import ConsistencyProblem from "@/sections/ConsistencyProblem";
import ConsequenceSim from "@/sections/ConsequenceSim";
import TwinButterfly from "@/components/TwinButterfly";

const SCIENCE_STOPS = [0, 0.15, 0.35, 0.55, 0.75, 1];
const SCIENCE_XS = ["80%", "24%", "90%", "12%", "84%", "18%"];
const SCIENCE_YS = ["30%", "20%", "28%", "62%", "22%", "36%"];

const Science = () => (
  <main data-testid="science-page" className="relative z-10">
    <TwinButterfly stops={SCIENCE_STOPS} xs={SCIENCE_XS} ys={SCIENCE_YS} />
    <ScienceTeam />
    <ConsistencyProblem />
    <ConsequenceSim />
  </main>
);

export default Science;
